/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Outcome_TitleInputs */

const en_mk_sol_outcome_title = /** @type {(inputs: Mk_Sol_Outcome_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What changes`)
};

const id_mk_sol_outcome_title = /** @type {(inputs: Mk_Sol_Outcome_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yang berubah`)
};

/**
* | output |
* | --- |
* | "What changes" |
*
* @param {Mk_Sol_Outcome_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_outcome_title = /** @type {((inputs?: Mk_Sol_Outcome_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Outcome_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_outcome_title(inputs)
	return en_mk_sol_outcome_title(inputs)
});